import type { Data } from '@/api/api.ts'
import axios from 'axios'
import { baseUrl } from '@/constants/api'

const urlPrefix = `${baseUrl}antifraud/`

export const requestVideo = async (): Promise<Data<any>> => {
  return axios.post(
    `${urlPrefix}video-identification/`,
    {},
    {
      headers: {
        'X-CSRFToken': CSRF_TOKEN,
      },
    },
  )
}
